module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-HAZEL-eng.8ca6d30a.png";